
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users-list/users.component';
import { UserFormModalComponent } from './user-add-form-modal/user-form-modal.component';
import { ChangePasswordModalComponent } from './user-change-password-modal/change-password-modal.component';
import { UserChangeRoleModalComponent } from './user-change-role-modal/user-change-role-modal.component';

const routes: Routes = [
  {
    path: '',
    component: UsersComponent,
    children: [
      {
        path: 'create',
        component: UserFormModalComponent,
      },
      {
        path: 'change-password',
        component: ChangePasswordModalComponent,
      },
      {
        path: 'change-role',
        component: UserChangeRoleModalComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule { }

